module.exports = __webpack_public_path__ + "static/media/tooltip-white-icon.5fdce4e6.svg";